import { internalFetch } from './fetchHelper';
import type { IUploadFileResponse } from './interfaces/UploadFileInterfaces';

export const uploadImage = async (
  abortController: AbortController,
  name: string,
  purpose: string,
  content: ArrayBuffer
): Promise<IUploadFileResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/image?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'POST',
    abortController,
    JSON.stringify({
      name: name,
      purpose: purpose,
      content: content,
    })
  );
};

export const uploadFile = async (
  abortController: AbortController,
  name: string,
  content: string
): Promise<IUploadFileResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/file?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'POST',
    abortController,
    JSON.stringify({
      name: name,
      content: content,
    })
  );
};

export const downloadFile = async (
  abortController: AbortController,
  url: string
): Promise<Response> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/downloadfile?url=${encodeURIComponent(url)}`,
    'GET',
    abortController,
    undefined,
    true
  );
};
